import { parse, unparse } from "papaparse";

import { FIELD_TYPES } from "base/constants";
import { CURRENCY_SYMBOLS } from "base/utils";
import { Utils } from "widgets/datetime";

const { formatDateToUTC, getDayjsObject } = Utils;

function csvToJSON(csvString) {
  const { data, errors } = parse(csvString, { delimiter: "\t" });
  if (errors && errors.length > 0) {
    return null;
  } else {
    return data;
  }
}

function jsonToCSV(obj) {
  return unparse(obj, { delimiter: "\t" });
}

function isValidDate(dateObj) {
  let ts = Date.parse(dateObj);
  return !isNaN(ts);
}
const DATE_REGX_1 = /^\d{4}([./-])\d{2}\1\d{2}$/;
const DATE_REGX_2 = /^\d{2}([./-])\d{2}\1\d{4}$/;
const TIME_REGX = /^\d{2}:\d{2}$/;
function stringToValue(string, type, options) {
  if (string === null || string === undefined) return null;
  try {
    switch (type.toLowerCase()) {
      case FIELD_TYPES.TEXT.toLowerCase():
      case FIELD_TYPES.TEXT_AREA.toLowerCase():
      case FIELD_TYPES.SELECT.toLowerCase():
        return string.trim() === "" ? null : string;
      case FIELD_TYPES.EMAIL.toLowerCase():
        return string;
      case FIELD_TYPES.NUMBER.toLowerCase():
      case FIELD_TYPES.SLIDER.toLowerCase():
        return parseFloat(string);
      case FIELD_TYPES.CURRENCY.toLowerCase():
        if (!string.trim()) return null;
        const parts = string.toString().split(" ");
        if (parts.length === 1 && !isNaN(string)) {
          return `${string} ${options.currencies[0]}`;
        }
        if (isNaN(parts[0])) {
          let currencyCode = options.currencies.find(
            (currency) => CURRENCY_SYMBOLS[currency] === parts[0]
          );
          if (!currencyCode) {
            currencyCode = options.currencies[0];
          }
          return `${string} ${currencyCode}`;
        } else {
          return string;
        }
      case FIELD_TYPES.BOOLEAN.toLowerCase():
        return (
          string === "1" ||
          string.toLowerCase() === "true" ||
          string.toLowerCase() === "yes"
        );
      case FIELD_TYPES.DATE.toLowerCase():
        if (!string) return null;
        let date = getDayjsObject(string);
        if (!isValidDate(date)) {
          throw new Error("Invalid date value");
        }
        return formatDateToUTC(date);
      case FIELD_TYPES.DATE_TIME.toLowerCase():
        if (!string) return null;
        let dateTime = (string && string.trim()) || "";
        let elem = dateTime.split(" ") || []; //if date + time
        let dateString = elem[0] || "";
        let timeString = elem[1] || "";
        let dateTimeObj = getDayjsObject(elem[0]); //if datetime UTC + timezone
        let isValidUTCFormat = isValidDate(dateTimeObj);
        let isValidDateFormat =
          DATE_REGX_1.test(dateString) || DATE_REGX_2.test(dateString);
        let isValidTimeFormat = TIME_REGX.test(timeString);
        let dateTimeString = isValidTimeFormat ? dateTime : dateString;

        if (isValidDateFormat || isValidTimeFormat) {
          return formatDateToUTC(getDayjsObject(dateTimeString), true);
        } else if (isValidUTCFormat) {
          return dateTime;
        } else {
          throw new Error("Invalid date and time value");
        }
      default:
        return JSON.parse(string);
    }
  } catch (err) {
    console.warn("ERROR DS", err);
    return null;
  }
}

function valueToString(value, type, options) {
  try {
    switch (type.toLowerCase()) {
      case FIELD_TYPES.TEXT.toLowerCase():
      case FIELD_TYPES.TEXT_AREA.toLowerCase():
      case FIELD_TYPES.EMAIL.toLowerCase():
      case FIELD_TYPES.SELECT.toLowerCase():
      case FIELD_TYPES.NUMBER.toLowerCase():
      case FIELD_TYPES.SLIDER.toLowerCase():
      case FIELD_TYPES.CURRENCY.toLowerCase():
      case FIELD_TYPES.DATE.toLowerCase():
      case FIELD_TYPES.DATE_TIME.toLowerCase():
        return value;
      case FIELD_TYPES.BOOLEAN.toLowerCase():
        return value ? "Yes" : "No";
      default:
        return value !== null ? JSON.stringify(value) : null;
    }
  } catch (err) {
    return null;
  }
}

export { csvToJSON, jsonToCSV, stringToValue, valueToString };
